import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// Layout Components
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';

// Page Components
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import Conference from './pages/Conference';
import News from './pages/News';
import Society from './pages/Society';
import BoardOfDirectors from './pages/BoardOfDirectors';
import Membership from './pages/Membership';
import MultinationalFinanceJournal from './pages/MultinationalFinanceJournal';
import PublicConferenceManuscripts from './pages/PublicConferenceManuscripts';
import ConferenceGallery from './pages/ConferenceGallery';

// Conference Components
import Conferences from './components/Conferences/Conferences';

// Auth Components
import Login from './components/Auth/Login';
import Profile from './components/Auth/Profile';
import Register from './components/Auth/Register';
import RegistrationConfirmation from './components/Auth/RegistrationConfirmation';
import AccountActivation from './components/Auth/AccountActivation';
import ForgotPassword from './components/Auth/ForgotPassword';
import ResetPassword from './components/Auth/ResetPassword';
import RequireAuth from './components/Auth/RequireAuth';

// Payment Components
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';

// Admin Components
import AdminDashboard from './components/Admin/AdminDashboard';

const App = () => { 
  // Validate components before rendering
  const isValidComponent = (component) => {
    return typeof component === 'function' || 
           (typeof component === 'object' && component !== null && typeof component.default === 'function');
  };

  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/profile"
          element={(
            <RequireAuth>
              <Profile />
            </RequireAuth>
          )}
        />
        <Route path="/register" element={<Register />} />
        <Route path="/registration-confirmation" element={<RegistrationConfirmation />} />
        <Route path="/activate-account" element={<AccountActivation />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/dashboard"
          element={(
            <RequireAuth>
              <Dashboard />
            </RequireAuth>
          )}
        />
        <Route path="/conferences" element={<Conferences />} />
        <Route path="/society/board" element={<BoardOfDirectors />} />
        <Route path="/society" element={<Society />} />
        <Route path="/conference/:id" element={<Conference />} />
        <Route path="/conference/:id/gallery" element={<ConferenceGallery />} />
        <Route path="/news/:id" element={<News />} />
        <Route
          path="/:conferenceCode/Manuscripts"
          element={(
            <RequireAuth>
              <PublicConferenceManuscripts />
            </RequireAuth>
          )}
        />
        <Route path="/registration/payment/success" element={<PaymentSuccess />} />
        <Route path="/registration/payment/cancel" element={<PaymentCancel />} />
        <Route
          path="/admin"
          element={(
            <RequireAuth roles={["admin"]}>
              <AdminDashboard />
            </RequireAuth>
          )}
        />
        <Route
          path="/admin/dashboard"
          element={(
            <RequireAuth roles={["admin"]}>
              <AdminDashboard />
            </RequireAuth>
          )}
        />
        <Route path="/membership" element={<Membership />} />
        <Route path="/journal" element={<MultinationalFinanceJournal />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;